import { UnderlineStyleEnum } from './types';

export const UNDERLINE_COLOURS: UnderlineStyleEnum[] = ['Blue', 'Green', 'Orange', 'Purple', 'Red'];

export const NOTIFICATION_DURATION = 6000;
